"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReserveVehicleMutation = exports.updateVehicleMutation = exports.removeVehiclesFromOrderMutation = exports.addVehiclesToOrderMutation = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.addVehiclesToOrderMutation = `
  mutation addVehiclesToOrder($orderId: ID!, $vehicles: [VehicleInput!], $options: [VehicleOptionInput!]) {
    addVehiclesToOrder(orderId: $orderId, vehicles: $vehicles, options: $options) {
      ...order
      ...nextError
    }
  }
  ${fragments_1.orderFragments}
  ${fragments_1.nextErrorFragment}
`;
exports.removeVehiclesFromOrderMutation = `
  mutation removeVehiclesFromOrder($orderId: ID!, $vehicles: [VehicleInput!], $options: [VehicleOptionInput!]) {
    removeVehiclesFromOrder(orderId: $orderId, vehicles: $vehicles, options: $options) {
      ...order
      ...nextError
    }
  }
  ${fragments_1.orderFragments}
  ${fragments_1.nextErrorFragment}
`;
exports.updateVehicleMutation = `
  mutation updateVehicle($id: String!, $input: VehicleInput!) {
    updateVehicle(id: $id, input: $input) {
      ...vehicle
    }
  }
  ${fragments_1.vehicleFragmentMinimal}
  ${fragments_1.referenceFragment}
  ${fragments_1.vehicleModelFragment}
`;
exports.updateReserveVehicleMutation = `
  mutation updateReserveVehicle($input: ReserveDetailsInput!){
    updateReserveVehicle(input: $input){
      quotationNumber
      reservationFromDate
      reservationToDate
      vehicleReserveStatus
    }
  }
`;
//# sourceMappingURL=vehicle.js.map